import React from 'react';
import CredentialTypeForm from './CredentialTypeForm';

const CreateCredentialType = ({ onSave, onCancel }) => (
  <CredentialTypeForm onSave={onSave} onCancel={onCancel} />
);

export default CreateCredentialType;
